import { render, staticRenderFns } from "./DialogChangeLog.vue?vue&type=template&id=10a2ed28&scoped=true&"
import script from "./DialogChangeLog.vue?vue&type=script&lang=js&"
export * from "./DialogChangeLog.vue?vue&type=script&lang=js&"
import style0 from "./DialogChangeLog.vue?vue&type=style&index=0&id=10a2ed28&lang=scss&scoped=true&"
import style1 from "./DialogChangeLog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a2ed28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10a2ed28')) {
      api.createRecord('10a2ed28', component.options)
    } else {
      api.reload('10a2ed28', component.options)
    }
    module.hot.accept("./DialogChangeLog.vue?vue&type=template&id=10a2ed28&scoped=true&", function () {
      api.rerender('10a2ed28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/DialogChangeLog.vue"
export default component.exports